module.exports = __webpack_public_path__ + "fonts/Open_Sans-300-greek8.ff43b05.woff2";